const { get, max, pickBy, keys, pick } = require('lodash');
const {
    CONFIGURABLE_PAYMENT_METHODS,
    paymentMethodConfigProp,
} = require('./paymentMethods');
const { campaignGatewayConfigs } = require('./campaign');

function getDefaultPaymentMethod(
    pagePayments,
    currency,
    { excludedPaymentMethods = [], paymentModeProp } = {},
) {
    const gatewayConfigList = get(pagePayments, currency, []);

    for (const method of CONFIGURABLE_PAYMENT_METHODS) {
        if (excludedPaymentMethods.includes(method)) {
            continue;
        }

        for (const config of gatewayConfigList) {
            if (
                get(config, paymentMethodConfigProp(method), false) &&
                (!paymentModeProp || get(config, paymentModeProp))
            ) {
                return method;
            }
        }
    }

    return null;
}

function getPaymentConfig(currencyPayments, paymentMethod) {
    if (!currencyPayments?.length) {
        return null;
    }

    const defaultConfig = currencyPayments[0];

    const methodConfigProp = paymentMethodConfigProp(paymentMethod);
    if (!methodConfigProp) {
        return defaultConfig;
    }

    const paymentConfig = currencyPayments.find(config =>
        get(config, methodConfigProp, false),
    );
    if (!paymentConfig) {
        return defaultConfig;
    }

    return paymentConfig;
}

function isPaymentMethodEnabled(currencyPayments, paymentMethod) {
    if (!currencyPayments?.length) {
        return false;
    }

    const methodConfigProp = paymentMethodConfigProp(paymentMethod);
    return currencyPayments.some(config =>
        get(config, methodConfigProp, false),
    );
}

const getPaymentModeCurrencies = (payments, paymentModeProp) => {
    const currencyConfigs = pick(payments, get(payments, 'currencies', []));
    const relevantConfigs = pickBy(
        currencyConfigs,
        gatewayConfigs =>
            gatewayConfigs.filter(gatewayConfig =>
                get(gatewayConfig, paymentModeProp, false),
            ).length,
    );
    return keys(relevantConfigs);
};

const getMaxRecurringMonths = payments => {
    const allGatewayConfigs = campaignGatewayConfigs({ payments });
    return max([
        -1,
        ...allGatewayConfigs
            .filter(({ allowRecurring }) => allowRecurring)
            .map(({ recurringMaxMonths }) => recurringMaxMonths),
    ]);
};

module.exports = {
    getDefaultPaymentMethod,
    getPaymentConfig,
    getPaymentModeCurrencies,
    isPaymentMethodEnabled,
    getMaxRecurringMonths,
};
